import { Modal } from 'antd';
import { FC, useState } from 'react';
import { Link } from 'react-router-dom';
import { useVerifyEmailMutation } from '../../../services';
import { toast } from 'react-toastify';
import { handleServerError } from '../../../helpers';


interface IProps {
  isModalVisible: boolean;
  handleCancel: () => void;
  openLogin: () => void;
}

const VerifyEmail: FC<IProps> = (props) => {
  const { isModalVisible, handleCancel, openLogin } = props;

  const [email, setEmail] = useState<string>('');

  const [verifyEmail, { isLoading }] = useVerifyEmailMutation();

  const handleOk = () => {
    if (!email) {
      toast.error('Please provide an email address');
    } else {
      verifyEmail({ email })
        .unwrap()
        .then(() => {
          toast.success(
            'An email containing your password reset token has been sent to your email address'
          );
          handleCancel();
        })
        .catch(handleServerError);
    }
  }

  return (
    <Modal visible={isModalVisible} okButtonProps={{ disabled: isLoading }}
           okText={isLoading ? 'Verifying...' : 'Verify'}
           onOk={handleOk} onCancel={handleCancel}>
      <header><h1>Verify Email</h1></header>
      <form>
        <div className="form-group">
          <label htmlFor="email">Email:</label>
          <input type="email" className="form-control" id="email"
                 value={email} onChange={(e) => {
                   setEmail(e.target.value);
                 }} name={"email"} required/>
        </div>
      </form>
      <hr/>
      <div className="center">
        <Link to="#" onClick={() => {
          handleCancel();
          openLogin();
        }}>Back to login</Link>
      </div>
    </Modal>
  );
}

export default VerifyEmail;